
<style lang="scss" scoped>
@import '@/core/assets/primevue/primeflex.scss';
</style>

<template>
    <Toast />
    <!-- <LoadingSpinner v-if="loader" size="5" color="fill-primary-600" classs="m-5" /> -->
    <LibraryUpload v-model:visible="imageUploadDialog" :path="endpoints.uploadlibrary" :slug="channel" @data="libraryUploadGetData" @finished="libraryUploadidFinished" />
    <Toolbar>
        <template #start>
            <Button v-tooltip.bottom="'Änderungen zurücksetzen'" @click="reset_changes()" class="mr-2 p-button-danger" icon="pi pi-refresh" />
            <Button @click="save_changes()" v-tooltip.bottom="'Änderungen Speichern'" label="Speichern" class="w-auto mr-4 p-button-success" icon="pi pi-save" />
            <Divider layout="vertical" />
            <Button v-tooltip.bottom="'Preview Artikel'" @click="save_preview" label="Vorschlau" class="mr-2 p-button w-auto" icon="pi pi-eye" />
            <Button v-tooltip.bottom="'Artikel schliessen'" @click="close_tab()" label="Schliessen" class="mr-2 p-button-danger w-auto" icon="pi pi-times-circle" />
        </template>
        <template #end>
            <Button type="button" icon="pi pi-refresh" aria-controls="overlay_menu" @click="reset_changes()" />
        </template>
    </Toolbar>
    <TabView class="col-12 mt-2" ref="tabview4">
        <TabPanel>
            <template #header>
                <i class="pi pi-file mr-2"></i>
                <span class="mr-3">Meta</span>
            </template>
            <div class="col-12 formgrid grid">
                <div class="field col-8 mt-3">
                    <Editor editorStyle="width: 100%; min-height: 350px;" v-model="blog.text_content">
                        <template v-slot:toolbar>
                            <span class="ql-formats">
                                <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                <button class="ql-link" v-tooltip.bottom="'Hyperlink'"></button>
                                <button class="ql-clean" v-tooltip.bottom="'Clear Format'"></button>
                            </span>
                        </template>
                    </Editor>

                    <div class="my-2">
                        <Panel header="Call to Action">
                            <div class="my-5">
                                <span class="p-float-label">
                                    <InputText id="cta_title" :autoResize="true" v-model="blog.cta_title" class="w-full" />
                                    <label for="cta_title">CTA Titel</label>
                                </span>
                            </div>
                            <div class="my-5">
                                <span class="p-float-label">
                                    <InputText id="cta_subtitle" :autoResize="true" v-model="blog.cta_subtitle" class="w-full" />
                                    <label for="cta_subtitle">CTA SubTitel</label>
                                </span>
                            </div>
                            <div class="my-5">
                                <span class="p-float-label">
                                    <Editor editorStyle="width: 100%; min-height: 350px;" v-model="blog.cta_teaser" placeholder="CTA Teaser">
                                        <template v-slot:toolbar>
                                            <span class="ql-formats">
                                                <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                                <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                                <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                                <button class="ql-link" v-tooltip.bottom="'Hyperlink'"></button>
                                                <button class="ql-clean" v-tooltip.bottom="'Clear Format'"></button>

                                            </span>
                                        </template>
                                    </Editor>
                                </span>
                            </div>
                        </Panel>
                    </div>
                </div>
                <div class="field col-4">
                    <div class="field col-12">
                        <Accordion class="accordion-custom mt-3" :activeIndex="0">
                            <AccordionTab>
                                <template #header>
                                    <span class="mr-2" style="font-size: 130%;">Metadaten</span>
                                </template>
                                <div class="field col-12 mt-5">
                                    <span class="p-float-label">
                                        <Dropdown id="blog_status" v-model="blog.status" :options="blog_status" optionLabel="name" optionValue="value" class="w-full" />
                                        <label for="blog_status">Status</label>
                                    </span>
                                </div>
                                <div class="field col-12 mt-5">
                                    <span class="p-float-label">

                                        <Dropdown id="blog_category" v-model="blog.category" :options="blog_categories" optionLabel="name" optionValue="value" class="w-full" />
                                        <label for="blog_category">Kategorie</label>
                                    </span>
                                </div>
                                <div class="field col-12 mt-5">
                                    <span class="p-float-label">
                                        <Textarea id="title" class="w-full" :autoResize="true" v-model="blog.title" />
                                        <label for="title">Titel</label>
                                    </span>
                                </div>
                                <div class="field col-12 mt-5">
                                    <span class="p-float-label">
                                        <Textarea id="teaser" class="w-full" :autoResize="true" v-model="blog.teaser" />
                                        <label for="teaser">Subheadline</label>
                                    </span>
                                </div>


                                <!-- <div class="field col-12 mt-5">
                                    <span class="p-float-label">
                                        <Dropdown id="author" v-model="blog.author" :options="users" optionLabel="user_fullname" optionValue="user_email" class="w-auto" />
                                        <label for="author">Autor</label>
                                    </span>
                                </div> 
                                 <div class="field col-12 mt-5">

                                    <span class="p-float-label">
                                        <Dropdown :filter="true" :showClear="true" id="user" v-model="blog.user" :options="users" optionLabel="user_fullname" optionValue="user_email" class="w-auto" />
                                        <label for="user">Bearbeiter</label>
                                    </span>
                                </div> -->
                                <div class="field col-12 mt-2">

                                    <Button @click="editTitleImageDialog = true" v-tooltip.bottom="'Titel-Bild editieren'" label="Titel-Bild" class="w-full mr-2 my-1 p-button" icon="pi pi-image" />

                                    <Button @click="editTitleImagePreviewDialog = true" v-tooltip.bottom="'Vorschau-Bild editieren'" label="Vorschau-Bild" class="w-full my-1 p-button" icon="pi pi-image" />
                                </div>
                            </AccordionTab>
                        </Accordion>
                    </div>
                    <div class="field col-12 mt-4">
                        <Accordion class="accordion-custom mt-3">
                            <AccordionTab>
                                <template #header>
                                    <i class="pi pi-image mr-2"></i>
                                    <span class="mr-2" style="font-size: 130%;">Bilder Bibliotek</span>
                                    <Avatar :label="String(image_library.length)" class="mr-2" shape="circle" />
                                </template>

                                <Galleria :value="image_library" v-model:activeIndex="activeImageIndex" :numVisible="7" containerStyle="max-width: 850px" :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false" v-model:visible="displayGallery">
                                    <template #item="slotProps">

                                        <img :src="slotProps.item.image" style="width: 100%; display: block;" />
                                    </template>
                                </Galleria>

                                <div v-if="image_library" class="grid">
                                    <div v-for="(image, index) of image_library" class="flex" :key="index">
                                        <img :src="image.image" class="shadow-2 m-2" style="cursor: pointer; width: 80px; height: 80px; object-fit: cover;" @click="showGallery(index)" />
                                    </div>
                                </div>
                                <div>
                                    <Button @click="imageUploadDialog = true" v-tooltip.bottom="'Bilder in die Bibliotek hochladen'" label="Bilder hochladen" class="mr-2 p-button w-auto" icon="pi pi-upload" />
                                    <!-- <Button @click="imageUploadDialog = true" v-tooltip.bottom="'Bilder aus der Bibliotek wählen'" label="Bibliotek" class="mr-2 p-button-success w-auto" icon="pi pi-folder" />  -->
                                </div>
                            </AccordionTab>
                        </Accordion>
                    </div>
                    <div class="field col-12 mt-4">
                        <Accordion class="accordion-custom mt-3">
                            <AccordionTab>
                                <template #header>
                                    <i class="pi pi-history mr-2"></i>
                                    <span class="mr-2" style="font-size: 130%;">Änderungsverlauf</span>
                                    <Avatar :label="String(blog_changes.length)" class="mr-2" shape="circle" />
                                </template>
                                <div v-if="blog_changes">
                                    <div v-for="(change, index) of blog_changes" :key="index">
                                        <Card style="width: 100%" class="mt-3 shadow-3">
                                            <template #content>
                                                <div class="flex">
                                                    <Chip :label="change.user" icon="pi pi-user" class="mr-3" />
                                                    <Chip :label="swiss_date_time(change.date)" icon="pi pi-clock" />
                                                </div>
                                                <div class="flex">
                                                    <span class="m-2 p-2 w-full" style="background-color: #b3e5fc; color: #23547b; border-radius: 3px;">{{ change.message }}</span>
                                                </div>
                                            </template>
                                        </Card>
                                    </div>
                                </div>
                            </AccordionTab>
                        </Accordion>
                    </div>
                </div>
            </div>
        </TabPanel>
        <TabPanel>
            <template #header>
                <i class="pi pi-box mr-2"></i>
                <span class="mr-3">Builder</span>
            </template>
            <div class="col-12 formgrid grid">
                <div class="field col-8 mt-3 p-0" style="border: 2px solid #e9ecef;">
                    <!--------------------------------------------------->
                    <!------------------ DataTable ---------------------->
                    <!--------------------------------------------------->
                    <DataTable :value="blog_content" :rows="20" responsiveLayout="scroll" :rowHover="true" @rowReorder="onRowReorder">
                        <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
                        <Column field="template">
                            <template #header>
                                <i class="pi pi-box mr-2"></i>
                                <span class="mr-3">Blocks</span>
                                <Avatar :label="String(blog_content.length)" shape="circle" class="mr-2 bg-primary-500 text-white" style="" />
                            </template>
                            <template #body="slotProps">

                                <StandardText v-if="slotProps.data.template == 'standard_text'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" />

                                <ImageTextBlock v-if="slotProps.data.template == 'image_text'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :image_library="image_library" :workflow_id="workflow_id" />

                                <QuotingLogoBlock v-if="slotProps.data.template == 'quoting_logo'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :image_library="image_library" :workflow_id="workflow_id" />

                                <ComparsionBlock v-if="slotProps.data.template == 'comparsion_block'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :workflow_id="workflow_id" />


                                <StandardTitle v-if="slotProps.data.template == 'standard_title'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" />

                                <StandardImage v-if="slotProps.data.template == 'standard_image'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :image_library="image_library" :workflow_id="workflow_id" />

                                <CTAButton v-if="slotProps.data.template == 'cta_button'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" />

                                <HtmlBlock v-if="slotProps.data.template == 'html_block'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" />

                                <QuoteBlock v-if="slotProps.data.template == 'quote_block'" :template_type="'data'" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :workflow_id="workflow_id" />

                                <VideoURL v-if="slotProps.data.template == 'video_url'" template_type="data" :index="slotProps.index" :data="slotProps.data" @block-callback="update_template_data" :workflow_id="workflow_id" />
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div class="field col-4 mt-3">
                    <div class="field col-12 mt-4">
                        <div v-for="key in content_blocks" :key="key">
                            <StandardText v-if="key == 'standard_text'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" />

                            <ImageTextBlock v-if="key == 'image_text'" :image_library="image_library" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" :workflow_id="workflow_id" />

                            <QuotingLogoBlock v-if="key == 'quoting_logo'" :image_library="image_library" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" :workflow_id="workflow_id" />

                            <ComparsionBlock v-if="key == 'comparsion_block'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" :workflow_id="workflow_id" />

                            <StandardTitle v-if="key == 'standard_title'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" />

                            <StandardImage v-if="key == 'standard_image'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" :image_library="image_library" :workflow_id="workflow_id" />
                            <CTAButton v-if="key == 'cta_button'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" />
                            <HtmlBlock v-if="key == 'html_block'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" />
                            <QuoteBlock v-if="key == 'quote_block'" :template_type="'menu'" :data="content_blocks" @block-callback="update_template_data" :workflow_id="workflow_id" />
                            <VideoURL v-if="key == 'video_url'" template_type="menu" :data="content_blocks" @block-callback="update_template_data" :workflow_id="workflow_id" />
                        </div>
                    </div>
                </div>
            </div>
        </TabPanel>
    </TabView>
    <!--------------------------------------------------->
    <!------------------- Dialogs ----------------------->
    <!--------------------------------------------------->

    <Dialog v-model:visible="blog_text_vorschlag_dialog" :style="{ width: '800px' }" header="Teaser Vorschlag" :modal="true" class="p-fluid">
        <div class="col-12 formgrid grid">
            {{ blog_text_vorschlag }}
        </div>
    </Dialog>
    <!--------------------------------------------------->
    <!--------------- Edit Title Image ------------------>
    <!--------------------------------------------------->
    <Dialog v-model:visible="editTitleImageDialog" :style="{ width: '80%' }" header="Titel Bild editieren" :modal="true" class="p-fluid">
        <div class="col-12 formgrid grid">
            <div v-if="edit_header_image == false" class="field col-12 mt-3">
                <img :src="blog.header_image" class="shadow-2" style="width: 100%; height: 100%; object-fit: cover;" />
            </div>

            <Button v-if="edit_header_image == false" label="Bild Bearbeiten" @click="edit_header_image = true" class="w-auto mr-3 mb-1 p-button" icon="pi pi-pencil" />

            <div v-if="edit_header_image == true" class="field col-12 mt-3">
                <cropper ref="title_image_cropper" :src="blog.header_image" :auto-zoom="true" :auto-center="true" />
            </div>

            <div v-if="edit_header_image == true" class="field col-12 mt-3">
                <div v-if="image_library" class="flex">
                    <div v-for="(img, index) of image_library" class="flex" :key="index">
                        <img @click="blog.header_image = img.image" :src="img.image" class="shadow-2 m-2" style="cursor: pointer; width: 80px; height: 80px; object-fit: cover;" />
                    </div>
                </div>
            </div>

            <div v-if="edit_header_image == true" class="field col-12 mt-3">
                <Button label="Bild Speichern" @click="crop_header_image(title_image_cropper, 'header_image')" class="w-auto mr-3 mb-1 p-success" icon="pi pi-save" />
                <!-- <Button @click="imageUploadDialog = true" v-tooltip.bottom="'Bilder in die Bibliotek hochladen'" label="Bilder hochladen" class="mr-2 p-button w-auto" icon="pi pi-upload" /> -->
            </div>
        </div>

    </Dialog>
    <!--------------------------------------------------->
    <!----------------- Preview Image ------------------->
    <!--------------------------------------------------->
    <Dialog v-model:visible="editTitleImagePreviewDialog" :style="{ width: '80%' }" header="Titel Vorschau-Bild editieren" :modal="true" class="p-fluid">
        <div class="col-12 formgrid grid">
            <div v-if="edit_header_image_preview == false" class="field col-12 mt-3">
                <img :src="blog.header_image_preview" class="shadow-2" style="width: 100%; height: 100%; object-fit: cover;" />
            </div>
            <Button v-if="edit_header_image_preview == false" label="Bild Bearbeiten" @click="edit_header_image_preview = true, blog.header_image_preview = blog.header_image" class="w-auto mr-3 mb-1 p-button" icon="pi pi-pencil" />
            <div v-if="edit_header_image_preview == true" class="field col-12 mt-3">
                <cropper ref="title_image_cropper_preview" :stencil-props="{ aspectRatio: 1 / 1 }" :src="blog.header_image_preview" :auto-zoom="true" :auto-center="true" />
            </div>
            <div v-if="edit_header_image_preview == true" class="field col-12 mt-3">
                <div v-if="image_library" class="flex">
                    <div v-for="(img, index) of image_library" class="flex" :key="index">
                        <img @click="blog.header_image_preview = img.image" :src="img.image" class="shadow-2 m-2" style="cursor: pointer; width: 80px; height: 80px; object-fit: cover;" />
                    </div>
                </div>
            </div>
            <div v-if="edit_header_image_preview == true" class="field col-12 mt-3">
                <Button label="Bild Speichern" @click="crop_header_image_preview(title_image_cropper_preview, 'header_image_preview')" class="w-auto mr-3 mb-1 p-success" icon="pi pi-save" />
                <!-- <Button @click="imageUploadDialog = true" v-tooltip.bottom="'Bilder in die Bibliotek hochladen'" label="Bilder hochladen" class="mr-2 p-button w-auto" icon="pi pi-upload" /> -->
            </div>
        </div>
    </Dialog>
    <!--------------------------------------------------->
    <!------------------- GPT Dialog -------------------->
    <!--------------------------------------------------->
    <Dialog v-model:visible="chatGptDialog" :style="{ width: '80%' }" header="Inhalte mit AI erstellen" :modal="true" class="p-fluid">
        <ChatGPT :questions="chatGptQuestions" @chat-callback="update_text_content" />
    </Dialog>
</template>

<script setup>
import { ref, onMounted, watch, defineProps, defineEmits, inject } from 'vue'
import { useToast } from 'primevue/usetoast'
import axios from 'axios'
import { useConfirm } from "primevue/useconfirm"
import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import LoadingSpinner from '@/core/components/UI/Loading-Spinner.vue'
import { useCustomerStore } from '@/core/store/CustomerStore'
import ChatGPT from '../Editor-Recipes/chat_gpt.vue'
import StandardText from '@/core/components/Components/Builder-Blocks/Standard-Text.vue'
import StandardImage from '@/core/components/Components/Builder-Blocks/Standard-Image.vue'
import StandardTitle from '@/core/components/Components/Builder-Blocks/Standard-Title.vue'
import CTAButton from '@/core/components/Components/Builder-Blocks/Cta-Button.vue'
import HtmlBlock from '@/core/components/Components/Builder-Blocks/Html-Block.vue'
import QuoteBlock from '@/core/components/Components/Builder-Blocks/Quote-Block.vue'
import ImageTextBlock from '@/core/components/Components/Builder-Blocks/Image-Text.vue'
import ComparsionBlock from '@/core/components/Components/Builder-Blocks/Comparsion-Block.vue'
import QuotingLogoBlock from '@/core/components/Components/Builder-Blocks/Quoting-Logo-Block.vue'
import VideoURL from '@/core/components/Components/Builder-Blocks/Video-URL.vue'
import Simplestore from '@/core/var/Simplestore';
import { swiss_date_time, preview_dataset } from '@/core/var/tools'
import { uploadSingleImage } from '@/core/var/crud'
import LibraryUpload from '@/core/components/Components/Main-Library-Upload.vue'


const content_blocks = ref(['standard_text',
    'standard_title',
    'standard_image',
    'cta_button',
    'html_block',
    'quote_block',
    'image_text',
    'comparsion_block',
    'quoting_logo',
    'video_url'])

const channel = ref(useCustomerStore().getCustomer.customer);

const SERVICE_URL = inject('SERVICE_URL')


const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()
const imageUploadDialog = ref(false)
const editTitleImageDialog = ref(false)
const editTitleImagePreviewDialog = ref(false)
const edit_header_image_preview = ref(false)
const edit_header_image = ref(false)

const props = defineProps({
    redis_key: { type: String }
})

const workflow_id = ref("")
const blog = ref([])
const blog_categories = ref([])
const blog_tags = ref([])
const blog_sort = ref([])
const blog_status = ref([])
const users = ref([])
const blog_content = ref([])
const image_library = ref([])
const activeImageIndex = ref(0)
const displayGallery = ref(false)
const blog_changes = ref([])
const chatGptQuestions = ref([])
const chatGptDialog = ref(false)
const blog_title = ref(null);
const blog_text_vorschlag = ref(null);
const blog_text_vorschlag_button_loading = ref(false);
const blog_text_vorschlag_dialog = ref(false);
const disabled = ref(false);
const title_image_cropper = ref();
const emits = defineEmits(['editorCallback'])
const title_image_cropper_preview = ref()

const MODULE = 'casestudies';

const endpoints = {
    get: "casestudies/get",
    getsingle: "casestudies/get-casestudie",
    savesingle: "/casestudies/save-single",
    getsystem: 'get-system',
    getcategories: 'casestudies/categories',
    gettags: 'casestudies/tags',
    getusers: 'get-users',
    save: 'casestudies/save',
    uploadsingle: 'casestudies/upload-image',
    uploadlibrary: 'casestudies/upload-library-image',
    preview: 'casestudies/preview/save'
}


onMounted(() => {
    loader.value = true;
    getBlogs().then(() => {
        loader.value = false;
    });
    fetchSystemAndUsers();
})

watch(loader, res => {
    Simplestore.spinner = res;
});


const fetchSystemAndUsers = async () => {
    try {
        const systemRequest = axios.get(`${process.env.VUE_APP_NEURAXIS_API_MAIN}/${channel.value}/${endpoints.getsystem}`);
        const usersRequest = axios.get(`${process.env.VUE_APP_NEURAXIS_API_MAIN}/${channel.value}/${endpoints.getusers}`);
        const categoriesRequest = axios.get(`${process.env.VUE_APP_NEURAXIS_API_MAIN}/${channel.value}/${endpoints.getcategories}`);

        const [systemResponse, usersResponse, categoriesResponse] = await Promise.all([systemRequest, usersRequest, categoriesRequest]);

        blog_categories.value = categoriesResponse.data;
        blog_tags.value = systemResponse.data.blog_tags;
        blog_sort.value = systemResponse.data.blog_sort;
        blog_status.value = systemResponse.data.blog_status;

        users.value = usersResponse.data;
    } catch (error) {
        console.error("Error fetching system and users data:", error);
    }
};


const getBlogs = async () => {
    const payload = { redis_key: props.redis_key };
    try {
        const response = await axios.post(`${process.env.VUE_APP_NEURAXIS_API_MAIN}/${channel.value}/${endpoints.getsingle}`, payload);
        const { data } = response;

        blog.value = data;
        blog.value.category = data.category[0];
        workflow_id.value = data.workflow_id;
        blog_content.value = data.content;
        blog_title.value = data.title;
        blog_changes.value = data.changes;
        image_library.value = data.image_library;
        GPT_Primer(blog_title.value);

    } catch (error) {
        console.error("Error fetching blog data:", error);
    }
};

const GPT_Primer = (blog_title) => {
    chatGptQuestions.value = [
        {
            question: `Erstelle ein Blog Post zum Thema ${blog_title}`,
            button_name: "Blog Post erstellen",
        },
        {
            question: `Erstelle ein Blog Post zum Thema ${blog_title} und fasse es mit 100 Wörtern zusammen`,
            button_name: "Blog Zusammenfassung (100 Wörter)",
        },
    ];
}

const update_text_content = (e) => {
    page.value["text_content"] += "<br><br>" + e.chatGptAnswers
    toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Inhalte wurden übernommen', life: 3000 })
    chatGptDialog.value = false
}


const close_tab = () => {
    confirm.require({
        message: 'Sind Sie sicher, dass Sie diesen Artikel schliessen wollen? Alle nicht gespeicherten Änderungen gehen verloren.',
        header: 'Artikel schliessen',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, Artikel schliessen',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            emits('editorCallback',
                {
                    "action": "close_tab",
                    "redis_key": props.redis_key
                }
            )
        }
    })
}

const showGallery = (index) => {
    activeImageIndex.value = index
    displayGallery.value = true
}

const update_template_data = (e) => {
    if (e.action == "save") {
        blog_content.value[e.index] = e.template_data
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Inhalt gespeichert', life: 3000 })
    } else if (e.action == "delete") {
        blog_content.value.splice(e.index, 1)
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Inhalt gelöscht', life: 3000 })
    } else if (e.action == "add") {
        blog_content.value.push(e.template_data)
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Inhalt hinzugefügt', life: 3000 })
    }
}

const save_changes = () => {
    loader.value = true;
    blog.value["content"] = blog_content.value
    blog.value["changes"] = blog_changes.value
    blog.value["image_library"] = image_library.value
    blog.value["category"] = [blog.value.category];
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + "/" + channel.value + endpoints.savesingle, blog.value)

        .then(response => {

            toast.add({ severity: 'success', summary: blog.value.title + ' gespeichert', detail: 'Änderungen wurden erfolgreich gespeichert', life: 3000 })
            loader.value = false;
            // tmp hack
            blog.value["category"] = blog.value.category[0];
        })
}

const save_preview = () => {
    const workload = {
        redis_key: blog.value.redis_key,
        content: blog.value.content,
        title: blog.value.title,
        teaser: blog.value.teaser,
        header_image: blog.value.header_image,
    };

    axios.post(`${process.env.VUE_APP_NEURAXIS_API_MAIN}/${channel.value}/${endpoints.preview}`, workload)
        .then(response => {
            preview_dataset(blog.value.slug, SERVICE_URL, MODULE)
        })
}

const reset_changes = () => {
    confirm.require({
        message: 'Wollen Sie wirklich alle Änderungen verwerfen?',
        header: 'Änderungen verwerfen',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, Änderungen verwerfen',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            let payload = { "redis_key": props.redis_key }
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + "/" + channel.value + "/" + endpoints.getsingle, payload)
                .then(response => {
                    blog.value = response.data
                })
        }
    })
}

const onRowReorder = (e) => {
    if (e.dragIndex != e.dropIndex) {
        blog_content.value = e.value
    }
}


const crop_header_image = async (image, image_type) => {

    await uploadSingleImage(image, image_type, blog.value.workflow_id, channel.value, endpoints.uploadsingle, true).then((res) => {
        toast.add({
            severity: "success",
            summary: "Erfolg",
            detail: "Bild erfolgreich hochgeladen",
            life: 3000,
        });

        blog.value.header_image = res.data.image_url;
        edit_header_image.value = false;
    });
}


const crop_header_image_preview = async (image, image_type) => {

    await uploadSingleImage(image, image_type, blog.value.workflow_id, channel.value, endpoints.uploadsingle, true).then((res) => {
        toast.add({
            severity: "success",
            summary: "Erfolg",
            detail: "Bild erfolgreich hochgeladen",
            life: 3000,
        });

        blog.value.header_image_preview = res.data.image_url
        edit_header_image_preview.value = false
    });
}





const libraryUploadGetData = (res) => {
    blog.value['image_library'].push({ image: res });
    console.log(image_library.value);
}

const libraryUploadidFinished = (res) => {
    if (res === true) {
        imageUploadDialog.value = false;
    }
}
</script>
